export default "__VITE_PUBLIC_ASSET__b325bdc4__"